import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function ComingSoon({ blurb, testid }) {
  return (
    <div
      data-testid={testid || "legal-coming-soon"}
      className="mt-6 rounded-2xl border border-stone-200 bg-white/70 backdrop-blur-sm px-6 py-10 sm:py-14 text-center shadow-sm"
    >
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#6B7A54]/10 mb-5">
        <Sparkles size={22} className="text-[#6B7A54]" />
      </div>
      <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-[#6B7A54] mb-2">
        Coming soon
      </div>
      <h2 className="font-[Cormorant_Garamond] italic text-2xl sm:text-3xl text-stone-900 mb-3">
        We&rsquo;re polishing this page
      </h2>
      <p className="font-[Manrope] text-[15px] leading-relaxed text-stone-600 max-w-md mx-auto">
        {blurb || "This page is being written. Please check back soon."}
      </p>
      <Link
        to="/"
        data-testid="legal-coming-soon-home-link"
        className="inline-block mt-7 text-xs font-[Manrope] font-bold tracking-[0.3em] uppercase text-[#6B7A54] border-b border-[#6B7A54]/40 pb-1 hover:border-[#6B7A54] transition-colors"
      >
        Back to Aynora
      </Link>
    </div>
  );
}
